import { msalConfig } from './authConfig'
import { fetchAccessTokenForCognitoUser, generateNewToken } from './authUtils'

export const clearStorage = (account) => {
  for (var key in sessionStorage) {
    if (
      key.startsWith(
        `cc.${msalConfig.auth.clientId}.${account.idTokenClaims.oid}`
      )
    )
      sessionStorage.removeItem(key)
  }
}

export const storeTokenData = (tokenData) => {
  localStorage.setItem('tokenData', JSON.stringify(tokenData))
}

export const retrieveTokenData = async (instance) => {
  const loginType = localStorage.getItem('loginType')
  let tokenData
  if (loginType === 'cognito') {
    tokenData = await fetchAccessTokenForCognitoUser()
  } else {
    tokenData = localStorage.getItem('tokenData')
    tokenData = JSON.parse(tokenData)

    if (!isTokenValid(tokenData)) {
      tokenData = await generateNewToken(instance)
    }
  }
  return tokenData
}

export const isTokenValid = (tokenData) => {
  const currentTimestamp = new Date().getTime() / 1000
  return (
    tokenData &&
    currentTimestamp < new Date(tokenData.expiresOn).getTime() / 1000
  )
}

export const updateTokenUsageTime = () => {
  const currentTime = new Date().getTime() / 1000
  sessionStorage.setItem('lastUsedTime', currentTime)
}